import axios from "axios";
import Cookies from "js-cookie";

export const openManagedUserGoals = ({ clientEmail, managerEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_HOME_API_DOMAIN}/getManagedUserJWT?email=${encodeURIComponent(clientEmail)}&userManagerEmail=${encodeURIComponent(managerEmail)}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${managerEmail}`)}`,
        },
      }
    )
    .then(response => {
      Cookies.set(
        `jwt__${decodeURIComponent(clientEmail)}`,
        response?.data?.jwt,
        {
          expires: 7,
          secure: true,
        }
      );

      window.open(
        `/dashboard?email=${encodeURIComponent(clientEmail)}`,
        "adminView"
      );
    });
